export default __webpack_public_path__ + "static/media/toyota.e9cf95ab.svg";